import { render, staticRenderFns } from "./DoctorMissedCallSettings.vue?vue&type=template&id=16f9c166&scoped=true&"
import script from "./DoctorMissedCallSettings.vue?vue&type=script&lang=js&"
export * from "./DoctorMissedCallSettings.vue?vue&type=script&lang=js&"
import style0 from "./DoctorMissedCallSettings.vue?vue&type=style&index=0&id=16f9c166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f9c166",
  null
  
)

export default component.exports